function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

var _diffInHours = /*#__PURE__*/_classPrivateFieldLooseKey("diffInHours");

var _buildTime = /*#__PURE__*/_classPrivateFieldLooseKey("buildTime");

/**
 * Hour module.
 * @module src/hour
 */

/** Class to calculate difference in hours between two hours. */
export class HourDifference {
  /**
   * Return difference between the end hour and start hour considering that order they are given.
   *
   * @param {String} startHour - string representing the previous hour
   * @param {String} endHour - string representing the latter hour
   * @return {Number} the difference in hours
   *
   * @example
   * HourDifference.orderedBetween('10:00', '12:00');
   * // returns 2
   *
   * @example
   * HourDifference.orderedBetween('12:00', '10:00');
   * // returns 22
   *
   * @example
   * HourDifference.orderedBetween('23:45', '00:15');
   * // returns 0.5
   *
   */
  static orderedBetween(startHour, endHour) {
    const startFHour = new FHour(startHour);
    const endFHour = new FHour(endHour);
    const startDay = 1;
    const endDay = FHour.compare(startFHour, endFHour) === 1 ? startDay + 1 : startDay;

    const startTime = _classPrivateFieldLooseBase(HourDifference, _buildTime)[_buildTime](startDay, startFHour);

    const endTime = _classPrivateFieldLooseBase(HourDifference, _buildTime)[_buildTime](endDay, endFHour);

    return _classPrivateFieldLooseBase(HourDifference, _diffInHours)[_diffInHours](startTime, endTime);
  }
  /**
   * Return difference between the end hour and start hour considering always the less hour first.
   *
   * @param {String} firstHour - string representing the hour
   * @param {String} secondHour - string representing the hour
   * @return {Number} the difference in hours
   *
   * @example
   * HourDifference.unorderedBetween('10:00', '12:00');
   * // returns 2
   *
   * @example
   * HourDifference.unorderedBetween('12:00', '10:00');
   * // returns 2
   *
   * @example
   * HourDifference.unorderedBetween('23:45', '00:15');
   * // returns 23.5
   *
   */


  static unorderedBetween(firstHour, secondHour) {
    const _sort$map = [new FHour(firstHour), new FHour(secondHour)].sort(FHour.compare).map(hour => _classPrivateFieldLooseBase(HourDifference, _buildTime)[_buildTime](1, hour.value)),
          _sort$map2 = _slicedToArray(_sort$map, 2),
          firstTime = _sort$map2[0],
          secondTime = _sort$map2[1];

    return _classPrivateFieldLooseBase(HourDifference, _diffInHours)[_diffInHours](firstTime, secondTime);
  }

}

function _diffInHours2(startTime, endTime) {
  const msInHour = 1000 * 60 * 60;
  return (endTime - startTime) / msInHour;
}

function _buildTime2(day, time) {
  return new Date(`2007-05-0${day}:${time}:00Z`);
}

Object.defineProperty(HourDifference, _buildTime, {
  value: _buildTime2
});
Object.defineProperty(HourDifference, _diffInHours, {
  value: _diffInHours2
});

var _checkFormat = /*#__PURE__*/_classPrivateFieldLooseKey("checkFormat");

var _splitedHour = /*#__PURE__*/_classPrivateFieldLooseKey("splitedHour");

class FHour {
  constructor(value) {
    Object.defineProperty(this, _splitedHour, {
      value: _splitedHour2
    });
    Object.defineProperty(this, _checkFormat, {
      value: _checkFormat2
    });
    this.HOUR_PATTERN = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
    this.value = value || '';

    _classPrivateFieldLooseBase(this, _checkFormat)[_checkFormat]();

    var _classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _splitedHour)[_splitedHour]();

    var _classPrivateFieldLoo2 = _slicedToArray(_classPrivateFieldLoo, 2);

    this.hourPart = _classPrivateFieldLoo2[0];
    this.minutePart = _classPrivateFieldLoo2[1];
  }

  toString() {
    return this.value;
  }

  static compare(first, second) {
    if (first.value === second.value) return 0;

    if (first.hourPart === second.hourPart) {
      return first.minutePart > second.minutePart ? 1 : -1;
    } else {
      return first.hourPart > second.hourPart ? 1 : -1;
    }
  }

}

function _checkFormat2() {
  if (this.value.match(this.HOUR_PATTERN)) return;
  throw new Error(`Hour '${this.value}' must be a valid hour with format HH:MM`);
}

function _splitedHour2() {
  return this.value.split(':').map(part => Number.parseInt(part));
}